module.exports = __webpack_public_path__ + "img/jf_home_10.1c1c0541.jpg";